import styled from "styled-components";
import { Spacer } from "../editor/EditorHelpers";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader, ModalScrollview, ModalWrapper, Overlay } from "../components/Modal";
import { useEffect } from "react";


export const ChallengeSubheader = styled.div`
  font-weight: 400;
  font-size: 1.15rem;
  text-align: center;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1.5rem;
`

export const ChallengeButtonBar = styled.div`
  display: flex; 
  gap: 1rem; 
  margin-top: 1.8rem; 
  margin-bottom: 1.9rem;
  margin-left: auto;
  margin-right: auto;
`;

export const CertificateContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: min(1000px, calc(70vh * 2322 / 1220));
  aspect-ratio: 2322 / 1220; 
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Times New Roman', Times, serif;
`;

export const SmallText = styled.div`
  font-weight: 400;
  font-size: 0.9rem;
  max-width: 450px;
  margin-right: auto;
  text-align: left;
  padding-top: 2px;
  margin-bottom: 1.5rem;
`

export const StatusText = styled.div`
  font-weight: 400;
  font-size: 1.15rem;
  text-align: left;
  margin-top: 1.5rem;
`



interface ChallengeLearnMoreProps {
  onClose: () => void;
}

export const ChallengeLearnMore: React.FC<ChallengeLearnMoreProps> = ({ onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const sectionMapper = (paragraph, index) => {
    return index === 0
      ? <LearnMoreHeader key={index}>{paragraph}</LearnMoreHeader>
      : <LearnMoreParagraph key={index}>{paragraph}</LearnMoreParagraph>
  }

  return (
    <>
      <Overlay onClick={onClose} />
      <ModalWrapper>
        <Modal style={{maxWidth: '700px'}}>
          <ModalHeader onClose={onClose}>{t('learn-more.button')}</ModalHeader>
          <ModalScrollview>
            <LearnMoreContainer>
              {t('challenge.learn-more.how_it_works').split('\n\n').map(sectionMapper)}
              <Spacer $height="1rem" />
              <img src="/certificates.jpg" alt="Certificates" style={{width: '100%'}} />
              <Spacer $height="2.5rem" />
              {t('challenge.learn-more.why_email').split('\n\n').map(sectionMapper)}
              <Spacer $height="2.5rem" />
              {t('challenge.learn-more.recover_access').split('\n\n').map(sectionMapper)}
              <Spacer $height="2.5rem" />
              {t('default.brochure.page3.top.text').split('\n\n').map(sectionMapper)}
              <Spacer $height="2.5rem" />
              {t('default.brochure.page2.bottom.text').split('\n\n').map(sectionMapper)}
            </LearnMoreContainer>
          </ModalScrollview>
        </Modal>
      </ModalWrapper>
    </>
  )
}

const LearnMoreContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 2rem;
  border-radius: 0.25rem;
  margin-bottom: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  max-width: 800px;
`

const LearnMoreHeader = styled.div`
  font-weight: 600;
  width: 100%;
  font-size: 1.2rem;
  text-align: left;
`

const LearnMoreParagraph = styled.div`
  margin-top: 1rem;
  font-size: 1.1rem;
`

